module.exports = __webpack_public_path__ + "static/media/20201219_140833_093_IMG_3498.5ebf66a5.jpg";